// ============================================
// AdWords Uzmanı - Blog Content
// ============================================

import { BlogContent } from '../../types';

export const adwordsUzmaniContent: BlogContent = {
  tableOfContents: [
    { id: "adwords-nedir", title: "AdWords Nedir?" },
    { id: "google-ads-farklari", title: "Google Ads Farkları" },
    { id: "gecis-sureci", title: "Geçiş Süreci" },
    { id: "uzman-secimi", title: "Uzman Seçimi" }
  ],
  content: [
    {
      type: "paragraph",
      value: "<strong>AdWords uzmanı</strong> ve Google Ads'e geçiş süreçleri. Platform farkları ve uzman seçimi."
    }
  ]
};

export default adwordsUzmaniContent;
